import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { ExportDialog } from './ExportDialog';
/** Existing async action menus can await the real shared chooser. Mount at the
 * body so sticky/transform ancestors cannot trap the modal below the page. */
export function openExportDialog(props) {
    const host = document.createElement('div');
    host.className = 'oq-auto-review-ui';
    // Dashboard menus portal at z-50 (SelectDropdown.tsx); keep them above the
    // page modal. The extension keeps its existing maximum stacking level.
    host.style.setProperty('--oq-export-z-index', '50');
    document.body.appendChild(host);
    const root = createRoot(host);
    const previousFocus = document.activeElement;
    return new Promise(resolve => {
        let results = null;
        let closed = false;
        const close = () => {
            if (closed)
                return;
            closed = true;
            document.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('pagehide', close);
            root.unmount();
            host.remove();
            if (previousFocus instanceof HTMLElement && previousFocus.isConnected)
                previousFocus.focus();
            resolve(results);
        };
        const onKeyDown = (event) => {
            if (event.defaultPrevented || document.querySelector('[role="listbox"]'))
                return;
            if (event.key === 'Escape') {
                event.preventDefault();
                close();
            }
            if (event.key === 'Tab') {
                const controls = Array.from(host.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), [tabindex="0"]')).filter(node => node.getClientRects().length > 0);
                const first = controls[0], last = controls[controls.length - 1];
                if (first && last && ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last) || !host.contains(document.activeElement))) {
                    event.preventDefault();
                    (event.shiftKey ? last : first).focus();
                }
            }
        };
        document.addEventListener('keydown', onKeyDown);
        window.addEventListener('pagehide', close);
        function Dialog() {
            useEffect(() => { host.querySelector('[aria-label="Close export dialog"]')?.focus(); }, []);
            return _jsx(ExportDialog, { ...props, isOpen: true, onClose: close, onExportComplete: (value, preparation) => { results = value; props.onExportComplete?.(value, preparation); } });
        }
        root.render(_jsx(Dialog, {}));
    });
}
//# sourceMappingURL=openExportDialog.js.map